/**
 * Game keys that receive special highlight styling in VIF progress bars
 * (darker trail color and distinct stroke color)
 */
export const vifHighlight = [
  'vif_add',
  'vif_add_rules_dd',
  'vif_add_1',
  'vif_sub',
  'vif_sub_rules_dd',
  'vif_sub_2',
  'vif_mul_rules_dd_2',
  'vif_mul',
  'vif_mul_1',
  'vif_div_rules_dd',
  'vif_div',
  'vif_div_1',
];
